import classNames from "classnames/bind";
import styles from "./Home.module.scss";
// Import Swiper React components
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Grid, Lazy, Scrollbar, FreeMode } from "swiper";
import Brands from "~/Data/Brands";
import AllCar from "~/Data";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import "swiper/css/lazy";
import "swiper/css/scrollbar";
import "swiper/css/free-mode";
import { handleHistoryView } from "~/hooks/function";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Blog from "~/components/Blog";
import BlogRank from "~/components/BlogRank";
const cx = classNames.bind(styles);
const Home = () => {
    console.log("home");
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    !mediaQuery && window.scrollTo(0, 0);
    let Cars = [...AllCar];
    Cars.length = 20;
    return (
        <>
            <div className={cx("all")}>
                {mediaQuery && (
                    <div className={cx("wrapper1")}>
                        <div className={cx("wrapper_swiper")}>
                            <div className={cx("news")}>
                                <div className={cx("news_big")}>
                                    <h4>
                                        Cuộc đua doanh số phân khúc xe bán tải
                                        tháng 7: Ford Ranger tiếp tục bỏ xa các
                                        đối thủ
                                    </h4>
                                    <div>
                                        <p>Lamborghini</p>
                                        <p>Đọc thêm</p>
                                    </div>
                                    <img
                                        alt=""
                                        src="https://muaxegiatot.vn/wp-content/uploads/2020/06/sieu-xe-la-gi-muaxegiatot-vn.jpg"
                                    />
                                </div>
                                <div className={cx("news_small")}>
                                    <div>
                                        <h4>
                                            Cuộc đua doanh số phân khúc xe bán
                                            tải tháng 7: Ford Ranger tiếp tục bỏ
                                            xa các đối thủ
                                        </h4>

                                        <img
                                            alt=""
                                            src="https://cdn.baogiaothong.vn/upload/images/2021-3/album_img/2021-09-11/img-bgt-2021-sieu-xe-nhanh-nhat-1-1631328099-width1004height565.jpg"
                                        />
                                    </div>
                                    <div>
                                        <h4>
                                            Tốn bao nhiêu để đổ đầy bình
                                            Lamborghini Aventador?
                                        </h4>
                                        <img
                                            alt=""
                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7TTYBYiOypowSN5OpNkC9NVxWkDheDUex9Fv-TBrlVY3Oe2PABcBmQg27d5Ed1aP4ZFY&usqp=CAU"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {mediaQuery && (
                    <div className={cx("brand_title")}>
                        <h1>Hãng siêu xe nổi tiếng</h1>
                        <span>
                            <Link to="/brands">
                                {" "}
                                Xem thêm
                                <i>
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </i>
                            </Link>
                        </span>
                    </div>
                )}
                <div className={cx("wrapper2")}>
                    <div className={cx("wrapper_swiper")}>
                        <Swiper
                            slidesPerView={8}
                            lazy={true}
                            freeMode={true}
                            grid={{
                                rows: 2,
                            }}
                            pagination={{
                                dynamicBullets: true,
                            }}
                            modules={[Pagination, Grid, Lazy, FreeMode]}
                            breakpoints={{
                                "@0.00": {
                                    slidesPerView: 5,
                                },
                                "@1.25": {
                                    slidesPerView: 7,
                                },
                                "@1.5": {
                                    slidesPerView: 8,
                                },
                            }}
                            className={cx("swiper")}
                        >
                            {" "}
                            {Brands.map((brand, index) => (
                                <SwiperSlide
                                    key={index}
                                    className={cx("swiper_item")}
                                >
                                    <Link
                                        className={cx("swiper_item-link")}
                                        to={brand.path}
                                    >
                                        <img
                                            className={cx("swiper-lazy")}
                                            loading="lazy"
                                            src={brand.avatar}
                                            alt={`Logo thương hiệu ${brand.brand}`}
                                        />
                                        <h6>{brand.brand}</h6>
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
                {!mediaQuery && (
                    <div className={cx("wrapper1")}>
                        <div className={cx("wrapper_swiper")}>
                            <div className={cx("news")}>
                                <div className={cx("news_big")}>
                                    <h4>
                                        Lorem ipsum, or lipsum as it is
                                        sometimes known, is dummy text used in
                                        laying out print,
                                    </h4>
                                    <div>
                                        <p>Lamborghini</p>
                                        <p>Đọc thêm</p>
                                    </div>
                                    <img
                                        alt=""
                                        loading="lazy"
                                        src="https://muaxegiatot.vn/wp-content/uploads/2020/06/sieu-xe-la-gi-muaxegiatot-vn.jpg"
                                    />
                                </div>
                                <div className={cx("news_small")}>
                                    <div>
                                        <h4>
                                            Lorem ipsum, or lipsum as it is
                                            sometimes known, is dummy text used
                                        </h4>

                                        <img
                                            alt=""
                                            loading="lazy"
                                            src="https://cdn.baogiaothong.vn/upload/images/2021-3/album_img/2021-09-11/img-bgt-2021-sieu-xe-nhanh-nhat-1-1631328099-width1004height565.jpg"
                                        />
                                    </div>
                                    <div>
                                        <h4>
                                            Tốn bao nhiêu để đổ đầy bình
                                            Lamborghini Aventador?
                                        </h4>
                                        <img
                                            alt=""
                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7TTYBYiOypowSN5OpNkC9NVxWkDheDUex9Fv-TBrlVY3Oe2PABcBmQg27d5Ed1aP4ZFY&usqp=CAU"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {mediaQuery && (
                    <div className={cx("brand_title")}>
                        <h2>Tin mới</h2>
                    </div>
                )}
                <Blog data={<BlogRank />}></Blog>
                <>
                    <div className={cx("brand_title")}>
                        <h2>Siêu xe nổi bật</h2>
                        <span>
                            <Link to="/brands">
                                Xem thêm
                                <i>
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </i>
                            </Link>
                        </span>
                    </div>

                    <div className={cx("wrapper3")}>
                        <div className={cx("wrapper_swiper")}>
                            <Swiper
                                slidesPerView={5}
                                lazy={true}
                                grid={{
                                    rows: 2,
                                }}
                                scrollbar={{
                                    hide: true,
                                }}
                                modules={[Grid, Lazy, Scrollbar]}
                                breakpoints={{
                                    "@0.00": {
                                        slidesPerView: 2,
                                        slidesPerGroup: 2,
                                    },
                                    "@1.25": {
                                        slidesPerView: 4,
                                    },
                                    "@1.5": {
                                        slidesPerView: 6,
                                    },
                                }}
                                className={cx("swiper")}
                            >
                                {" "}
                                {Cars.map((car, index) => (
                                    <SwiperSlide
                                        key={index}
                                        className={cx("swiper_item")}
                                        onClick={() => handleHistoryView(car)}
                                    >
                                        <Link
                                            className={cx("swiper_item-link")}
                                            to={car.link}
                                        >
                                            <img
                                                className={cx("swiper-lazy")}
                                                loading="lazy"
                                                src={car.avatar}
                                                alt={car.name}
                                            />

                                            <h5>{car.name}</h5>
                                            <div className={cx("car_info")}>
                                                <p>{car.brand}</p>
                                                <p>{car.price} Tỷ</p>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

export default Home;
